<script>
import Response from "./ResultadoApi.vue";
import EnvolvidoProcessosFormModal from "./EnvolvidoProcessosFormModal.vue";
import playground from "../../../mixins/playground/playground";

export default {
  name: "EnvolvidoProcessos",
  mixins:[playground],
  components: { Response, EnvolvidoProcessosFormModal },
  props: {
    token: {
      type: String,
      required: true,
    },
    extra: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      termo: "",
      filtros: {
        tribunais: [],
        status: null,
        incluir_homonimos: false,
        dateOne: "",
        dateTwo: "",
      },
    };
  },
  computed: {
    verificarCpf() {
      return !this.verificarTermoString() && this.limparTermo().length === 11;
    },
    quantidadeFiltros() {
      let total = 0;

      if (this.filtros.status !== null) total++;
      if (this.verificarCpf && this.filtros.incluir_homonimos) total++;
      if (this.filtros.dateOne.length) total++
      if (this.filtros.dateTwo.length) total++
      total += this.filtros.tribunais.length;

      return total;
    },
    informacoes() {
      if(!this.response['envolvido_encontrado']) {
        return null;
      }

      let info = [
        {label: 'Nome', value: this.response['envolvido_encontrado']['nome'] },
        {label: 'Processos encontrados', value: this.response['envolvido_encontrado']['quantidade_processos'] },
      ];

      if(this.response['envolvido_encontrado']['tipo_pessoa']) {
        let tipoPessoa = this.response['envolvido_encontrado']['tipo_pessoa'] === 'FISICA' ? 'Física' : 'Jurídica'
        info.push({
          label: 'Tipo', value: 'Pessoa ' + tipoPessoa
        })
      }

      if (this.response['envolvido_encontrado']['tipo_pessoa'] === 'FISICA') {
        info.push({
          label: 'CPFs com esse nome',
          value: this.response['envolvido_encontrado']['cpfs_com_esse_nome']
        });
      }

      return info;
    }
  },
  methods: {
    limparTermo() {
      return this.termo.replace(/[^0-9]/g, '');
    },
    openModal() {
      if(!this.verificarCpf) this.filtros.incluir_homonimos = false;

      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    atualizarFiltro(filtro) {
      Object.assign(this.filtros, filtro);
    },
    inputInvalido() {
      return this.termo.length === 0;
    },
    verificarTermoString() {
      return /[a-zA-Z]/.test(this.termo)
    },
    params() {
      const tipoTermo = this.verificarTermoString() ? "nome" : "cpf_cnpj";

      let searchParams = {
        [tipoTermo]: this.termo,
        token_id: this.token,
      }

      if (this.verificarCpf) {
        searchParams['incluir_homonimos'] = this.filtros.incluir_homonimos ? 1 : 0;
      }

      if (this.filtros.status !== null) {
        searchParams['status'] = this.filtros.status ? 'ATIVO' : 'INATIVO';
      }

      if (this.filtros.dateOne.length) {
        searchParams['data_minima'] = this.filtros.dateOne;
      }

      if (this.filtros.dateTwo.length) {
        searchParams['data_maxima'] = this.filtros.dateTwo;
      }

      if (this.filtros.tribunais.length) {
        searchParams['tribunais'] = this.filtros.tribunais;
      }

      return { query: searchParams };
    },

  },
};
</script>

<template>
  <div>
    <form id="form-playground-envolvido" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="termo" class="font-medium text-sm">Nome, CPF ou CNPJ</label>
          <input
            id="termo"
            name="termo"
            v-model="termo"
            class="input is-large px-2 rounded-md block"
            type="text"
            autofocus="autofocus"
          />
      </div>
    </form>

    <Btn
      class="btn playground-button filtro-button"
      type="button"
      :disabled="$wait.is(`fetching_${this.identificador}`)"
      @click="openModal">
      Filtros <span>{{ quantidadeFiltros }}</span>
    </Btn>

    <div class="custo">
      <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${this.identificador}`)"
      :disabled="$wait.is(`fetching_${this.identificador}`) || inputInvalido()  || showModal"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>

    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :informacoes-principais="informacoes"
      @carregar-mais-envolvido-processos="carregarMais()"
    >
    </Response>

    <envolvido-processos-form-modal
      :visible="showModal"
      :tribunais="extra.tribunais"
      :filtros="filtros"
      :termoCpf="verificarCpf"
      @addFiltro="atualizarFiltro"
      @closeModal="closeModal"
    />
  </div>
</template>

<style scoped lang="stylus">
.custo
  width 25rem

  @media (max-width: 768px)
    width 100%

.form-playground
  display flex
  flex-direction column
  gap 15px

.form-playground .input
  width 25rem

  @media (max-width: 768px)
    width 100%

.filtro-button
  padding 10px 20px
  margin-top 1rem

.filtro-button span
  color #2393ae
  background-color ghostwhite
  padding 10px
  border-radius 50%
  margin-left 8px

.playground-button
  background-color #2393ae
  color #fff
  font-size 12px
  border-radius 5px
  font-weight 500

.playground-button:hover
  opacity 0.8

.consultar-button
  padding 20px 40px
</style>
